import { c as _c } from "react/compiler-runtime";
import { AspectRatio, Avatar, Badge, Box, Button, ButtonProps, Separator, Flex, HStack, Heading, Link, SimpleGrid, Text, VStack, StackProps } from '@chakra-ui/react';
import { AttendEventButton } from '@src/components/sco/Events/AttendEventButton';
import { OfficeHoursScheduler } from '@src/components/sco/Events/OfficeHoursScheduler';
import { getEventJoinWindow, getJoinEventPath } from '@src/components/sco/Events/eventJoinWindow';
import { TruncatedMarkdownRenderer } from '@src/components/sco/MarkdownRenderer/TruncatedMarkdownRenderer';
import { PaywalledAction } from '@src/components/sco/PaywalledAction';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { GroupEvent } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import moment from 'moment';
import { FaClock } from 'react-icons/fa';
import { FaCalendar } from 'react-icons/fa6';
export type EventCardProps = {
  descriptionHeightInPx?: number;
  event?: GroupEvent;
  title?: string;
  fluidHero?: boolean;
  mobileHero?: boolean;
  hideButtons?: boolean;
  showDescription?: boolean;
  hideDetails?: boolean;
  hideHosts?: boolean;
  showTypeAndTopics?: boolean;
  showTitleDate?: boolean;
  buttonStackProps?: StackProps;
};
export const CategoryButton = props => {
  const $ = _c(3);
  const t0 = props.bgColor as string || "action.primary";
  const t1 = props.title || "Event";
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = <Badge bgColor={t0}>{t1}</Badge>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const EventCard = props => {
  const $ = _c(77);
  useBreakpointContext();
  const {
    event
  } = props;
  if (!event) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <>Event Not Provided</>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const detailsUrl = `/events/${event.groupEventId}`;
  let t0;
  if ($[1] !== event.endsAt || $[2] !== event.startsAt) {
    t0 = getEventJoinWindow(event.startsAt, event.endsAt);
    $[1] = event.endsAt;
    $[2] = event.startsAt;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const {
    canBeJoined,
    isHappeningNow,
    isStartingSoon
  } = t0;
  let t1;
  if ($[4] !== event) {
    t1 = getJoinEventPath(event);
    $[4] = event;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const joinPath = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["2", "4"];
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== event.startsAt || $[8] !== isHappeningNow || $[9] !== isStartingSoon || $[10] !== props.showTitleDate) {
    t3 = props.showTitleDate && !isHappeningNow && !isStartingSoon && event.startsAt && <HStack><FaCalendar size="12px" /><Heading size={["xs", "sm"]}>{moment(event.startsAt).format("ddd MMM D")}<Text as="span" opacity={0.6}>  at  </Text>{moment(event.startsAt).format("h:mm a")}</Heading></HStack>;
    $[7] = event.startsAt;
    $[8] = isHappeningNow;
    $[9] = isStartingSoon;
    $[10] = props.showTitleDate;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== event.isFree) {
    t4 = event.isFree && <HStack><Heading size={["xs", "sm"]}>Public Event</Heading></HStack>;
    $[12] = event.isFree;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== isHappeningNow) {
    t5 = isHappeningNow && <HStack><FaClock size="12px" /><Heading size={["xs", "sm"]}>Happening Now!</Heading></HStack>;
    $[14] = isHappeningNow;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== isStartingSoon) {
    t6 = isStartingSoon && <HStack><FaClock size="12px" /><Heading size={["xs", "sm"]}>Starting Soon!</Heading></HStack>;
    $[16] = isStartingSoon;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["flex-start", "center"];
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ["md", "xl"];
    t9 = ["left", "center"];
    $[19] = t8;
    $[20] = t9;
  } else {
    t8 = $[19];
    t9 = $[20];
  }
  let t10;
  if ($[21] !== isHappeningNow || $[22] !== isStartingSoon) {
    t10 = !isHappeningNow && !isStartingSoon ? [2, 2, 2, 2, 3, 3] : [1, 2, 2, 2, 3, 3];
    $[21] = isHappeningNow;
    $[22] = isStartingSoon;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== detailsUrl || $[25] !== event.title) {
    t11 = <NextLink href={detailsUrl}>{event.title}</NextLink>;
    $[24] = detailsUrl;
    $[25] = event.title;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11) {
    t12 = <Heading size={t8} textAlign={t9} width="full"><Link asChild={true} color="white" lineClamp={t10}>{t11}</Link></Heading>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== event.topics || $[31] !== event.type || $[32] !== props.showTypeAndTopics) {
    t13 = props.showTypeAndTopics && <Box textAlign="center" width="100%">{event.type && <CategoryButton bgColor={event.type.colorHexCode} title={event.type.title} />}{event.topics && <>{event.topics.filter(_temp).map(_temp2)}{event.topics.filter(_temp3).map(_temp4)}</>}</Box>;
    $[30] = event.topics;
    $[31] = event.type;
    $[32] = props.showTypeAndTopics;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t12 || $[35] !== t13) {
    t14 = <VStack alignItems={t7} width="full">{t12}{t13}</VStack>;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t14 || $[38] !== t3 || $[39] !== t4 || $[40] !== t5 || $[41] !== t6) {
    t15 = <VStack alignItems="center" gap={t2} width="100%">{t3}{t4}{t5}{t6}{t14}</VStack>;
    $[37] = t14;
    $[38] = t3;
    $[39] = t4;
    $[40] = t5;
    $[41] = t6;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  const titleContents = t15;
  let t16;
  if ($[43] !== event.type?.colorHexCode || $[44] !== props.fluidHero || $[45] !== titleContents) {
    t16 = props.fluidHero ? <Box borderTop="1px solid rgba(255, 255, 255, 0.1)" borderTopRadius="2xl" height="full" paddingBottom={8} paddingTop={10} paddingX={4} width="full" bgColor={{
      _dark: `${event.type?.colorHexCode || "#000000"}50`,
      _light: `${event.type?.colorHexCode || "#000000"}`
    }}>{titleContents}</Box> : <AspectRatio borderTop="1px solid rgba(255, 255, 255, 0.1)" borderTopRadius="2xl" maxW="full" ratio={[4, 1.7777777777777777]} width="full" bgColor={{
      _dark: `${event.type?.colorHexCode || "#000000"}50`,
      _light: `${event.type?.colorHexCode || "#000000"}`
    }}><Flex alignContent={["flex-start", "center"]} justifyContent={["flex-start", "center"]} padding={["6", "8"]} width="full" zIndex={1}>{titleContents}</Flex></AspectRatio>;
    $[43] = event.type?.colorHexCode;
    $[44] = props.fluidHero;
    $[45] = titleContents;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  let t17;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = [3, 6];
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  let t19;
  let t20;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = ["none", "1px solid"];
    t19 = ["transparent", "border.muted"];
    t20 = ["0", "1em"];
    $[48] = t18;
    $[49] = t19;
    $[50] = t20;
  } else {
    t18 = $[48];
    t19 = $[49];
    t20 = $[50];
  }
  let t21;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Text opacity={0.6} textStyle="label">{"Time & Date"}</Text>;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== event.startsAt || $[53] !== props.event.startsAt) {
    t22 = <VStack alignItems="left" borderBottom={t18} borderColor={t19} paddingBottom={t20} width="full">{t21}{props.event.startsAt ? <Heading size={["xs", "sm"]}>{moment(event.startsAt).format("dddd MMM Do")}<Text as="span" opacity={0.6}>  at  </Text>{moment(event.startsAt).format("h:mm a")}{" "}{new Date().toLocaleTimeString("en-us", {
          timeZoneName: "short"
        }).split(" ")[2]}</Heading> : <Heading size={["xs", "sm"]}>By Appointment</Heading>}</VStack>;
    $[52] = event.startsAt;
    $[53] = props.event.startsAt;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== event.description || $[56] !== props.descriptionHeightInPx || $[57] !== props.showDescription) {
    t23 = props.showDescription && event.description && <><Text opacity={0.6} textStyle="label">Description</Text><TruncatedMarkdownRenderer baseFontSize="15" maxHeightInPx={props.descriptionHeightInPx} shadowEndColor="colorPalette.subtle" shadowStartColor="transparent">{event.description}</TruncatedMarkdownRenderer><Separator borderColor="border.muted" marginBottom="1em" /></>;
    $[55] = event.description;
    $[56] = props.descriptionHeightInPx;
    $[57] = props.showDescription;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== event.hosts || $[60] !== props.hideHosts) {
    t24 = !props.hideHosts && event.hosts && <VStack alignItems="left" height="full" width="full"><Text opacity={0.6} textStyle="label">Hosted By</Text><SimpleGrid columns={[2, 1]} gap={[1, 3]}>{event.hosts.map(_temp5)}</SimpleGrid></VStack>;
    $[59] = event.hosts;
    $[60] = props.hideHosts;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] !== canBeJoined || $[63] !== detailsUrl || $[64] !== event || $[65] !== joinPath || $[66] !== props.buttonStackProps || $[67] !== props.hideButtons) {
    t25 = !props.hideButtons && <><Separator width="full" /><VStack align="stretch" justify="stretch" width="full" {...props.buttonStackProps}><Button asChild={true} flexGrow={1} size="lg" variant="outlineSolid"><NextLink href={detailsUrl}>Details</NextLink></Button>{event.typeKey === "office-hours" ? <OfficeHoursScheduler buttonProps={{
          size: "lg"
        }} event={event} /> : <PaywalledAction tokens={event.title ? {
          eventName: event.title
        } : undefined} upgradeCtaLabel="Attend" contentPermission={event.isFree ? null : event.isPremium ? "canAccessFGPremiumEvents" : "canAccessFGBasicEvents"}>{canBeJoined && joinPath ? <Button asChild={true} bg="action.active" color="black" size={["sm", "md"]} variant="solid" width="full"><a href={joinPath} rel="noreferrer" target="_blank">Join Event Now</a></Button> : <AttendEventButton buttonProps={{
            size: "lg"
          }} event={event} />}</PaywalledAction>}</VStack></>;
    $[62] = canBeJoined;
    $[63] = detailsUrl;
    $[64] = event;
    $[65] = joinPath;
    $[66] = props.buttonStackProps;
    $[67] = props.hideButtons;
    $[68] = t25;
  } else {
    t25 = $[68];
  }
  let t26;
  if ($[69] !== t22 || $[70] !== t23 || $[71] !== t24 || $[72] !== t25) {
    t26 = <VStack alignItems="flex-start" alignSelf="stretch" flex="1 0 0" gap={3} padding={t17} width="full">{t22}{t23}{t24}{t25}</VStack>;
    $[69] = t22;
    $[70] = t23;
    $[71] = t24;
    $[72] = t25;
    $[73] = t26;
  } else {
    t26 = $[73];
  }
  let t27;
  if ($[74] !== t16 || $[75] !== t26) {
    t27 = <Box width="full"><VStack bgColor="colorPalette.muted" borderRadius="2xl" boxShadow="sm" gap={0} height="full" overflow="hidden" transition="background-color 0.2s ease-in" width="full">{t16}{t26}</VStack></Box>;
    $[74] = t16;
    $[75] = t26;
    $[76] = t27;
  } else {
    t27 = $[76];
  }
  return t27;
};
export const eventCardGroupEventFragment = gql`
  fragment EventCardGroupEvent on GroupEvent {
    id
    groupEventId
    title
    description
    typeKey
    topicKeys
    startsAt
    endsAt
    callUrl
    schedulingUrl
    isFutureEvent
    isCurrentUserAttending
    isPremium
    isFree
    eventAirtableRecordIdentifier
    hosts {
      id
      firstName
      lastName
      pictureUrl
      tagline
    }
    topics {
      id
      colorHexCode
      description
      isPrimary
      title
    }
    type {
      id
      title
      description
      colorHexCode
    }
  }
`;
function _temp(t) {
  return t.isPrimary && t.title;
}
function _temp2(topic) {
  return <CategoryButton key={topic.title} bgColor={topic.colorHexCode} title={topic.title} />;
}
function _temp3(t_0) {
  return !t_0.isPrimary && t_0.title;
}
function _temp4(topic_0) {
  return <CategoryButton key={topic_0.title} bgColor={topic_0.colorHexCode} title={topic_0.title} />;
}
function _temp5(host, i) {
  return <HStack key={i} gap="8px" justify="left"><Avatar.Root size={["xs", "md"]}><Avatar.Fallback name={`${host.firstName} ${host.lastName}`} /><Avatar.Image src={host.pictureUrl} /></Avatar.Root><Box><Text fontSize={["xs", "sm"]} fontWeight="medium">{host.firstName} {host.lastName}</Text>{host.tagline && <Text fontFamily="Poppins, sans-serif" fontSize="10px" fontWeight={600} lineClamp={[1, 2]} opacity={0.6}>{host.tagline}</Text>}</Box></HStack>;
}